import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXmark,
  faCopy,
  faShareNodes,
  faCircleCheck,
  faTrophy,
  faCashRegister,
  faWandSparkles,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { useUserContext } from "../../context";
import { colors } from "../../devdata/constants/themes";
import { Tooltip } from "antd";

const Modal = ({ isVisible, onClose, children }) => {
  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center transition-all duration-300 ${isVisible
        ? "visible backdrop-blur-sm bg-black bg-opacity-20"
        : "invisible"
        }`}
    >
      <div className="relative bg-darkMode-background text-white p-6 rounded-3xl border-2 border-darkMode-layer3 shadow-xl max-w-md w-full">
        <button
          className="absolute top-4 right-4 px-2 py-1 text-gray-400 hover:text-gray-300 rounded-full bg-darkMode-layer2"
          onClick={onClose}
        >
          <FontAwesomeIcon icon={faXmark} className="h-4 w-4 text-red-800" />
        </button>
        {children}
      </div>
    </div>
  );
};

const ReferralModal = ({ showModal, setShowModal }) => {
  const [copied, setCopied] = useState(false);
  const { userdetails } = useUserContext();
  const referralLink = `https://marketpulse.exchange/signup?refcode=${userdetails.referralCode}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };


  return (
    <Modal isVisible={showModal} onClose={() => setShowModal(false)}>
      <div className="p-4 sm:p-6">
        <div className="flex flex-col items-center pb-4 text-center">
          <div className="bg-yellow-500 p-4 rounded-full mb-3">
            <FontAwesomeIcon
              icon={faTrophy}
              size="3x"
              className="text-darkMode-background"
            />
          </div>
          <h2 className="text-darkMode-green text-lg sm:text-xl font-semibold">
            Refer your friends
          </h2>
          <p className="text-base sm:text-lg font-bold mt-2 text-darkMode-text -mx-5">
            Give 1 Month <span className="text-darkMode-green">FREE!</span> — Get 3 Months <span className="text-darkMode-green">FREE!</span>
          </p>
        </div>

        <ul className="mt-6 space-y-4 text-darkMode-subText text-sm sm:text-base">
          <li className="flex items-start">
            <FontAwesomeIcon
              icon={faCheck}
              className="text-darkMode-green h-4 w-4 ml-2 mr-4 mt-1"
            />
            <div>
              <p className="font-bold">Your Friend Gets:</p>
              <p>1 month free subscription to MarketPulse Pro (Valued at ₹583 — part of the ₹6,999 yearly plan)</p>
            </div>
          </li>
          <li className="flex items-start">
            <FontAwesomeIcon
              icon={faCheck}
              className="text-darkMode-green h-4 w-4 ml-2 mr-4 mt-1"
            />
            <div>
              <p className="font-bold">You Get:</p>
              <p>3 months free extension on your own MarketPulse Pro subscription</p>
            </div>
          </li>
          <li className="flex items-start">
            <FontAwesomeIcon
              icon={faCheck}
              className="text-darkMode-green h-4 w-4 ml-2 mr-4 mt-1"
            />
            <div>
              <p className="font-bold">No Limit on Referrals</p>
              <p>Refer as many friends as you want — every successful referral = 3 bonus months for you!</p>
            </div>
          </li>
        </ul>

        <div className="flex flex-col sm:flex-row gap-3 mt-6 justify-center items-center w-full">
          <div className="bg-darkMode-layer2 px-4 py-3 rounded-lg flex items-center justify-between w-full sm:w-3/5">
            <span className="truncate text-darkMode-text text-sm sm:text-base">
              {userdetails?.subscription !== "Yearly" ? "******" : userdetails.referralCode}
            </span>
            <Tooltip
              title={
                userdetails?.subscription !== "Yearly"
                  ? "Upgrade to Yearly Plan to get referral benefits"
                  : "Copy a sharable link"
              }
            >
              <button
                disabled={userdetails?.subscription !== "Yearly"}
                onClick={() => handleCopy()}
                className="text-darkMode-subText hover:text-darkMode-text flex items-center gap-2 text-sm sm:text-base"
              >
                <FontAwesomeIcon icon={faCopy} size="sm" /> Copy
              </button>
            </Tooltip>
          </div>
          <button className="w-full sm:w-2/5 bg-darkMode-layer2 text-darkMode-subText text-sm sm:text-base font-semibold py-3 rounded-lg flex items-center justify-center gap-2 hover:bg-darkMode-green hover:text-darkMode-layer3 transition-colors duration-200">
            <FontAwesomeIcon icon={faShareNodes} size="sm" /> Share link
          </button>
          {copied && (
            <p className="text-black text-sm sm:text-base mt-3 text-center bg-darkMode-green rounded-md p-2 fixed bottom-[15%] flex items-center justify-center gap-2 w-24">
              <FontAwesomeIcon icon={faCircleCheck} color={colors.darkMode.background} size="sm" />
              Copied!
            </p>
          )}
        </div>
        <div className="mt-4 text-xs sm:text-sm text-darkMode-subText">
          <span className="font-semibold">*Note:</span>
          <span className="font-light"> Referral bonus is only applicable when your friend purchases the Yearly MarketPulse Pro membership using your referral link.</span>
        </div>
      </div>
    </Modal>

  );
};

export default ReferralModal;
